export default "__VITE_ASSET__aXJWFhyZ__"